"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components")); // export const Flex = styled.div`
//   flex: 1;
// `;


exports.FlexItem = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex: 1;\n"], ["\n    flex: 1;\n"])));
exports.Flexbox = styled_components_1.default.div(function (props) {
  return {
    display: 'flex',
    alignItems: props.alignItems || '',
    alignContent: props.alignContent || '',
    flexDirection: props.column !== undefined ? 'column' : 'row',
    justifyContent: props.justifyContent || ''
  };
}); // export const Flexbox = styled.div<{ column?: string }>`
//     display: flex;
//     flex-direction: ${({ column }) => column && "column"};
// `;

/**
 * The only true button.
 *
 * @version 1.0.1
 * @component
 */

exports.default = exports.Flexbox;
var templateObject_1;